import { render, staticRenderFns } from "./CanceledTemplate.vue?vue&type=template&id=35a1e520"
import script from "./CanceledTemplate.vue?vue&type=script&lang=js"
export * from "./CanceledTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports